// extracted by mini-css-extract-plugin
module.exports = {"group":"style_group__2An3H","active":"style_active__o37uI","head":"style_head__18mtw","menu":"style_menu__Qm9jE","link":"style_link__10mes"};